import React from 'react';
import { TextDomain } from '../constants/TextDomain';

const { __ } = window.wp.i18n;

interface SurveyIntroProps {}

const SurveyIntro: React.FC<SurveyIntroProps> = (props) => {
    const {} = props;

    return (
        <div className="text intro">
            <p>{__('Test yourself out and find out how alcohol affects your life.', TextDomain)}</p>
            <p
                dangerouslySetInnerHTML={{
                    __html: __(
                        'This test was created by professionals in alcoholism curing and prevention from Sananim, and is based on WHO audit.',
                        TextDomain
                    ),
                }}
            />
            <p>
                {__(
                    'Alcohol consumption may be a risk for your health and may affect some medication effects, hence we consider important to ask in the test about your drinking habits.',
                    TextDomain
                )}
            </p>
            <p>
                {__(
                    "Your answers in the test are considered confidential, so they stay anonymous and won't be stored, neither shared. Try to choose answers that describe you the most.",
                    TextDomain
                )}
            </p>
            <p>{__('The test may take up 3-5 minutes.', TextDomain)}</p>
        </div>
    );
};

export default SurveyIntro;
